export default __webpack_public_path__ + "static/card-front-flipped-034420f7a38011ad640c5aa3fb134ac6.png";